import React from 'react';

import styled from 'styled-components';

import FilterItem from './FilterItem';
import { useMaterialsTableContext } from '../MaterialsTableContext';

const Wrapper = styled.div`
  align-items: flex-start;
  align-content: flex-start;
  display: flex;
  flex-wrap: wrap;
  gap: 0.625rem 1.25rem;
  padding-bottom: 3.125rem;
`;

/**
 * @todo translate
 */
// const camelCased = r
//   .toLowerCase()
//   .replace(/_([a-z])/g, g => g[1].toUpperCase());
export default function Filters() {
  const { allFilters } = useMaterialsTableContext();

  return (
    <Wrapper>
      <FilterItem filter={'ALL'} />
      {allFilters.map(filter => (
        <FilterItem key={filter} filter={filter} />
      ))}
    </Wrapper>
  );
}
